export default __webpack_public_path__ + "static/media/cooker_550_340.266cc3ce.jpg";